import { render } from "./WorkGuidanceFloatingBall.vue?vue&type=template&id=bfdf5bec&scoped=true"
import script from "./WorkGuidanceFloatingBall.vue?vue&type=script&lang=js"
export * from "./WorkGuidanceFloatingBall.vue?vue&type=script&lang=js"

import "./WorkGuidanceFloatingBall.vue?vue&type=style&index=0&id=bfdf5bec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfdf5bec"]])

export default __exports__